var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-item',{ref:"templateItemRef",attrs:{"show-actions":false,"title":_vm.title,"model":_vm.$productIngredientGroup,"show-delete":false,"after-save":_vm.afterSave},scopedSlots:_vm._u([{key:"default",fn:function({ object, rules }){return [_c('ProductIngredientGroupTabs'),_c('router-view')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }